import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { WorldMap } from '../world-map.model';
import { WorldMapActions, WorldMapActionTypes } from '../actions/world-map.actions';

export interface State extends EntityState<WorldMap> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<WorldMap> = createEntityAdapter<WorldMap>({
  selectId: info => info.Id
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(
  state = initialState,
  action: WorldMapActions
): State {
  switch (action.type) {
    case WorldMapActionTypes.AddWorldMap: {
      return adapter.addOne(action.payload.worldMap, {...state, Loading: false, Loaded: true});
    }

    case WorldMapActionTypes.UpsertWorldMap: {
      return adapter.upsertOne(action.payload.worldMap, state);
    }

    case WorldMapActionTypes.AddWorldMaps: {
      return adapter.addMany(action.payload.worldMaps, state);
    }

    case WorldMapActionTypes.UpsertWorldMaps: {
      return adapter.upsertMany(action.payload.worldMaps, state);
    }

    case WorldMapActionTypes.UpdateWorldMap: {
      return adapter.updateOne(action.payload.worldMap, {...state, Loading: false, Loaded: true});
    }

    case WorldMapActionTypes.UpdateWorldMaps: {
      return adapter.updateMany(action.payload.worldMaps, state);
    }

    case WorldMapActionTypes.DeleteWorldMap: {
      return adapter.removeOne(action.payload.id, {...state, Loading: false, Loaded: true});
    }

    case WorldMapActionTypes.DeleteWorldMaps: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case WorldMapActionTypes.LoadWorldMaps: {
      return adapter.setAll(action.payload.worldMaps, {...state, Loaded: true, Loading: false});
    }

    case WorldMapActionTypes.ClearWorldMaps: {
      return adapter.removeAll(state);
    }

    case WorldMapActionTypes.GetWorldMaps: {
      return {...state, Loading: true, Loaded: false};
    }

    case WorldMapActionTypes.GetAddWorldMaps: {
      return {...state, Loading: true, Loaded: false};
    }

    case WorldMapActionTypes.GetUpdateWorldMaps: {
      return {...state, Loading: true, Loaded: false};
    }

    case WorldMapActionTypes.GetDeleteWorldMaps: {
      return {...state, Loading: true, Loaded: false};
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
